import React from 'react';
import styled from 'styled-components';

const WrapDiv = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;
const ContainerLabel = styled.label`
  display: block;
  position: relative;
  padding-left: 29px;
  cursor: pointer;
  font-size: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 12px 0px;
  & span {
    position: absolute;
    top: 2px;
    left: 0;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    border: 2px solid #1E2228;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }
  & input {
    width: 0px;
    position: absolute;
    opacity: 0;
    &:checked ~ span {
      border: none;
      background-color: #FF2C91;
    }
  }
`;

const RadioButton = (props) => {
  return (
    <WrapDiv style={{ width: props.width ? `${props.width}` : '100%' }}>
      { props.list && props.list.map((item, index) => (
        <ContainerLabel
          key={`${props.radioName}_${index}`}
          style={{ width: props.rowItemCount ? `${100 / props.rowItemCount}%` : '25%' }}
        >
          {item.title}
          <input type="radio" checked={item.selected} name={props.radioName} onChange={() => props.selected(index, props.listName, props.radioName)} />
          <span />
        </ContainerLabel>
      )) }
    </WrapDiv>
  );
}

export default RadioButton;